import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './HomePage.css';
import AboutCompanySection from '../components/AboutCompanySection';
import ServicesSection from '../components/ServicesSection';
import ProductCategoriesSection from '../components/ProductCategoriesSection';
import ImplementedProjectsSection from '../components/ImplementedProjectsSection';
import PartnersSection from '../components/PartnersSection';

const Home = () => {
    return (
        <>
            {/* Главный баннер */}
            <div className="main-banner">
                {/* Вертикальный градиентный блюр */}
                <div className="overlay">
                    <div className="desktop-blur"></div>
                    <div className="desktop-blur-transition"></div>
                    <div className="mobile-blur"></div>
                </div>

                <Container className="h-100 position-relative">
                    <Row className="h-100 align-items-center">
                        <Col lg={7} md={9} className="text-white banner-content">
                            <h1 className="banner-title">
                                Комплексные решения в рамках программы «Доступная среда»
                            </h1>
                            <p className="lead mb-3">
                                Оборудование для создания доступной среды в государственных учреждениях
                            </p>
                            <p className="lead mb-5">
                                Полный цикл работ: от проектирования до обучения персонала
                            </p>
                            <div className="banner-buttons">
                                <Link to="/catalog">
                                    <Button 
                                        variant="warning"
                                        className="text-white catalog-button"
                                    >
                                        Перейти в каталог <FaArrowRight className="ms-2" />
                                    </Button>
                                </Link>
                                <a href="tel:+73452614940">
                                    <Button 
                                        variant="outline-light"
                                        className="survey-button"
                                    >
                                        Заказать обследование
                                    </Button>
                                </a>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            
            {/* Другие блоки страницы */}
            <AboutCompanySection />
            <ProductCategoriesSection />
            <ServicesSection />
            <ImplementedProjectsSection />
            <PartnersSection />
        </>
    );
}

export default Home;